export const createApiThunk = ({
  action,
  request,
  onResolved,
  onRejected,
  rejectOnError,
  start = true,
  passPayloadToError = false
}) => (payload, params = {}) => async (dispatch, getState) => {
  const prevState = getState();
  try {
    start && dispatch(action.start(payload));

    const response = await request(payload, prevState, dispatch);

    dispatch(action.resolve(response));

    if (onResolved) {
      onResolved({
        response,
        getState,
        dispatch,
        payload,
        params,
        prevState
      });
    }

    return response;
  } catch (error) {
    console.error(error);
    dispatch(action.reject(passPayloadToError ? { payload, error } : error));

    if (onRejected) {
      onRejected({
        error,
        getState,
        dispatch,
        payload,
        params,
        prevState
      });
    }

    return rejectOnError ? Promise.reject(error) : error;
  }
};
